// 管理员路由配置
export const adminRoutes = [
  {
    path: "/admin/login",
    name: "admin-login",
    meta: { title: "控制台登录" },
    component: () => import("@/views/admin/Login.vue"),
  },
  {
    name: "admin",
    path: "/admin",
    redirect: "/admin/dashboard",
    component: () => import("@/views/admin/Home.vue"),
    meta: { title: "海牛AI控制台" },
    children: [
      {
        path: "/admin/dashboard",
        name: "admin-dashboard",
        meta: { title: "仪表盘" },
        component: () => import("@/views/admin/Dashboard.vue"),
      },
      {
        path: "/admin/system",
        name: "admin-system",
        meta: { title: "系统设置" },
        component: () => import("@/views/admin/SysConfig.vue"),
      },
      {
        path: "/admin/user",
        name: "admin-user",
        meta: { title: "用户管理" },
        component: () => import("@/views/admin/Users.vue"),
      },
      {
        path: "/admin/app",
        name: "admin-app",
        meta: { title: "应用列表" },
        component: () => import("@/views/admin/Apps.vue"),
      },
      {
        path: "/admin/app/type",
        name: "admin-app-type",
        meta: { title: "应用分类" },
        component: () => import("@/views/admin/AppType.vue"),
      },
      {
        path: "/admin/apikey",
        name: "admin-apikey",
        meta: { title: "API-KEY 管理" },
        component: () => import("@/views/admin/ApiKey.vue"),
      },
      {
        path: "/admin/chat/model",
        name: "admin-chat-model",
        meta: { title: "语言模型" },
        component: () => import("@/views/admin/ChatModel.vue"),
      },
      {
        path: "/admin/product",
        name: "admin-product",
        meta: { title: "充值产品" },
        component: () => import("@/views/admin/Product.vue"),
      },
      {
        path: "/admin/order",
        name: "admin-order",
        meta: { title: "充值订单" },
        component: () => import("@/views/admin/Order.vue"),
      },
      {
        path: "/admin/redeem",
        name: "admin-redeem",
        meta: { title: "兑换码管理" },
        component: () => import("@/views/admin/Redeem.vue"),
      },
      {
        path: "/admin/loginLog",
        name: "admin-loginLog",
        meta: { title: "登录日志" },
        component: () => import("@/views/admin/LoginLog.vue"),
      },
      {
        path: "/admin/chats",
        name: "admin-chats",
        meta: { title: "对话管理" },
        component: () => import("@/views/admin/ChatList.vue"),
      },
      // {
      //   path: "/admin/images",
      //   name: "admin-images",
      //   meta: { title: "绘图管理" },
      //   component: () => import("@/views/admin/ImageList.vue"),
      // },
      {
        path: "/admin/medias",
        name: "admin-medias",
        meta: { title: "音视频管理" },
        component: () => import("@/views/admin/Medias.vue"),
      },
      {
        path: "/admin/courseVideo",
        name: "admin-courseVideo",
        meta: { title: "课程视频管理" },
        component: () => import("@/views/admin/CourseVideo.vue"),
      },
      {
        path: "/admin/courseMaterial",
        name: "admin-courseMaterial",
        meta: { title: "课程课件管理" },
        component: () => import("@/views/admin/CourseMaterial.vue"),
      },
      {
        path: "/admin/teaching-resource",
        name: "admin-teaching-resource",
        meta: { title: "教学资源" },
        component: () => import("@/views/admin/TeachingResource.vue"),
      },
      {
        path: "/admin/powerLog",
        name: "admin-power-log",
        meta: { title: "算力日志" },
        component: () => import("@/views/admin/PowerLog.vue"),
      },
      {
        path: "/admin/manger",
        name: "admin-manger",
        meta: { title: "管理员" },
        component: () => import("@/views/admin/Manager.vue"),
      },
    ],
  }
];